export default {
      id: "whatsapp-flat-usage",
      viewBox: "0 0 29 29",
      url: __webpack_public_path__ + "img/icons.c3436384.svg#whatsapp-flat",
      toString: function () {
        return this.url;
      }
    }